<template>
  <div class='contact'>
    <div class='content'>
      <div class='title'>联系我们</div>
      <ul class='con'>
        <li class='contactAdd'>
          <div class='company'>辽宁思凯科技股份有限公司</div>
          <ul>

            <li class='add'>
              <p>地址</p>
              <p>辽宁省丹东市边境经济合作区港湾工业区C区18号</p>
            </li>
            <li class='phone'>
              <p>电话</p>
              <p>0415-3151611/0415-3144734</p>
            </li>
            <li class='fax'>
              <p>传真</p>
              <p>0415-3144109</p>
            </li>
            <li class='email'>
              <p>E-mail</p>
              <p>market@chnsce.com</p>
            </li>
            <li class='postal'>
              <p>邮编</p>
              <p>118002</p>
            </li>
          </ul>
        </li>
        <li class='service'>
          <ul>
            <li>
              <p>售后客服电话</p>
              <p>4008701770</p>
            </li>
            <li>
              <p>思凯销售电话</p>
              <p>0415-3144734</p>
            </li>
            <li>
              <p>思凯招聘电话</p>
              <p>0415-6270120</p>
            </li>
          </ul>
        </li>
      </ul>
    </div>
    <div id='map' class='map'>
      <Map :center="mapCenter" :zoom="mapZoom" @markerClick="handleMarkerClick"></Map>

    </div>
  </div>
</template>

<script>
import Map from '../components/Map.vue'

export default {
  name: 'Contact',
  components: {
    Map,
  },
  data() {
    return {
      mapCenter: [124.334301, 40.063369],
      mapZoom: 18,
    };
  },
  methods: {
    handleMarkerClick(marker) {
      // 处理标记点击事件
    },
  },
  props: {
    // msg: String
  }
}
</script>

<style scoped>
.contact {
  display: flex;
  flex-direction: column;
}
.content {
  display: flex;
  flex-direction: column;
  width: 90%;
  margin: 15vw auto;
  text-align: left;
}
.title {
  color: #333333;
  font-size: 5vw;
  margin-bottom: 20px;
}

.con {
  display: flex;
  flex-direction: column;
  margin-bottom: 0;
}

/*公司地址等蓝色区域样式*/
.contactAdd {
  flex-grow: 1;
  background-color: #448CD3;
  padding:9.375vw 7.5vw;
  text-align: left;
  color: #fff;
  font-size: 3vw;
}

.contactAdd ul li {
  margin-top: 9.375vw;
  margin-bottom: 5.625vw;
  height: 10vw;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: left center;

}

.contactAdd ul li p {
  line-height: 4vw;
  padding-left: 13.125vw;
  margin-top: 0.5625vw;
  margin-bottom: 0.9375vw;
}
.contact ul li:first-of-type {
  font-size: 3.75vw;
}

.contact ul li p:first-of-type {
  font-size: 3.5vw;
}
/*公司名称样式*/
.company {
  padding-top: 20px;
  margin-bottom: 40px;
  font-size: 5vw;
  position: relative;

}
.company:after{
  content: '';
  /* 使用伪元素添加横线 */
  position: absolute;
  /* 设置绝对定位 */
  left: 0;
  /* 横线的左边与文字对齐 */
  bottom: -5px;
  /* 横线的底部与文字对齐 */
  width: 13%;
  /* 横线的宽度 */
  height: 0.375vw;
  /* 横线的高度 */
  background: #fff;
  /* 横线的颜色 */
  transition: background-color 0.3s;
  /* 可选：为横线添加过渡效果 */
}
.add {
  background-image: url('../assets/add@2x.png');
}

.phone {
  background-image: url('../assets/phone@2x.png');
}

.fax {
  background-image: url('../assets/fax@2x.png');
}

.email {
  background-image: url('../assets/email@2x.png');
}

.postal {
  background-image: url('../assets/postal@2x.png');
}
/*电话样式*/
.service {
  flex-grow: 1;
  background-color: #F5F5F5;
  padding-top: 9.375vw;
  padding-bottom: 25vw;
  padding-left:  7.5vw;
  vertical-align: middle;
  text-align: left;
  background-image: url('../assets/service.png');
  background-repeat: no-repeat;
  background-size: 70vw 40vw;
  background-position: bottom right;
}

.service ul li {
  line-height: 4.5vw;
  margin-top: 5.625vw;
  margin-bottom: 5.625vw;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: left center;
}

.service ul li p {
  margin-top: 0.5625vw;
  margin-bottom: 0.9375vw;
  font-size: 4.5vw;
}

.map {
  width: 100%;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: top center;
}
@media (min-width: 768px) {
  .content {
    display: flex;
    flex-direction: column;
    width: 680px;
    margin: 80px auto;
    font-size: 18px;
    line-height: 30px;
  }
  .title {
    font-size: 30px;
    margin-bottom: 50px;

  }
  /*公司名称样式*/
  .company {
    padding-top: 40px;
    margin-bottom: 70px;
    font-size: 28px;
  }
  .company:after{
    content: '';
    /* 使用伪元素添加横线 */
    position: absolute;
    /* 设置绝对定位 */
    left: 0;
    /* 横线的左边与文字对齐 */
    bottom: -5px;
    /* 横线的底部与文字对齐 */
    width: 60px;
    /* 横线的宽度 */
    height: 2px;
    /* 横线的高度 */
    background: #fff;
    /* 横线的颜色 */
    transition: background-color 0.3s;
    /* 可选：为横线添加过渡效果 */
  }
/*地址等样式*/
  .contactAdd {
    background-color: #448CD3;
    padding:50px 60px;
    text-align: left;
    color: #fff;
    font-size: 16px;
  }

  .contactAdd ul li {
    margin-top: 50px;
    margin-bottom:30px;
    height: 50px;
    background-repeat: no-repeat;
    background-size: contain;
    background-position: left center;

  }

  .contactAdd ul li p {
    line-height: 22px;
    padding-left: 70px;
    margin-top: 10px;
    margin-bottom: 5px;
  }
  .contact ul li:first-of-type {
    font-size: 20px;
  }

  .contact ul li p:first-of-type {
    font-size: 22px;
  }
  /*电话样式*/
  .service {
    padding-top: 40px;
    padding-bottom: 200px;
    padding-left:  60px;
    background-repeat: no-repeat;
    background-size: 500px 300px;
    background-position: bottom right;
  }

  .service ul li {
    line-height: 30px;
    margin-top: 50px;
    margin-bottom: 50px;
  }

  .service ul li p {
    font-size: 30px;
  }

}

@media (min-width: 960px) {
  .content {
    display: flex;
    flex-direction: column;
    width: 900px;
    margin: 80px auto;
    font-size: 18px;
    line-height: 30px;
  }

  .con {
    display: flex;
    flex-direction: row;
    margin-bottom: 0;
  }

  .contactAdd {
   flex-basis: 150px;
  }

  .service {
    flex-grow: 1;
  }
}
@media (min-width: 1200px) {
  .content {
    width: 1200px;
}
}

</style>